import { TLocale } from '@ps-int/general-themes-components/locales/i18n';

type Importer = () => Promise<TLocale>;

let localeObject: TLocale | null = null;
let importLocalePromise: ReturnType<Importer> | null = null;

const localeImporters: Record<typeof LANG, Importer> = {
    ru: () => import(/* webpackChunkName: "general-themes-ru" */ '@ps-int/general-themes-components/locales/i18n/ru'),
    en: () => import(/* webpackChunkName: "general-themes-en" */ '@ps-int/general-themes-components/locales/i18n/en'),
    tr: () => import(/* webpackChunkName: "general-themes-tr" */ '@ps-int/general-themes-components/locales/i18n/tr'),
    uk: () => import(/* webpackChunkName: "general-themes-ru" */ '@ps-int/general-themes-components/locales/i18n/ru'),
};

export async function importLocale(lang: typeof LANG): Promise<TLocale> {
    if (localeObject) {
        return Promise.resolve(localeObject);
    }

    if (importLocalePromise) {
        return importLocalePromise;
    }

    const importer = localeImporters[lang];

    importLocalePromise = importer().then((d) => {
        localeObject = d;

        return localeObject;
    });

    return importLocalePromise;
}

export function getLocale(): TLocale | null {
    return localeObject;
}
